// extracted by mini-css-extract-plugin
module.exports = {"dealCard":"DealCard_dealCard__30sfx","contentContainer":"DealCard_contentContainer__3U0xr","title":"DealCard_title__2ymyH","smallTitle":"DealCard_smallTitle__2twPS"};